/**
 * Seeded default field-report guide template created by the API when
 * `ensure_default` was previously used (see public/docs/modules/REPORT_GUIDES.md).
 *
 * We hide it on report/calendar surfaces only so users who never configured a
 * guide are not prompted. Admins still see it under Rapportguider where it can
 * be edited or removed.
 */

const STOCK_TITLE_NORMALIZED = new Set(["anlegg må skiftes ut"]);

function normalizedTitle(template) {
  return String(template?.title ?? "")
    .trim()
    .toLowerCase();
}

export function isPromangStockReportGuideTemplate(template) {
  if (!template || typeof template !== "object") return false;
  if (template.promang_stock_default === true) return true;
  if (template.stock_default === true) return true;
  if (template.is_system_default === true) return true;
  const title = normalizedTitle(template);
  if (!title) return false;
  return STOCK_TITLE_NORMALIZED.has(title);
}

export function excludingPromangStockReportGuideTemplates(templates) {
  if (!Array.isArray(templates)) return [];
  return templates.filter((t) => !isPromangStockReportGuideTemplate(t));
}
